<div *ngIf="loading" class="help-page-state" role="status">
	Loading help articles...
</div>

<div *ngIf="errorMessage" class="help-page-state help-page-state--error" role="alert">
	{{ errorMessage }}
</div>

<al-freshdesk-help-modal
	#helpViewer
	[backdrop]="false"
	[fullPage]="true"
	[canPopOutArticles]="false"
	[canRefreshArticles]="canRefreshArticles">
</al-freshdesk-help-modal>
